if (!customElements.get('merchandise-type-disclosure')) {
  class MerchandiseTypeDisclosure extends HTMLElement {
    connectedCallback() {
      if (this.toggle) return;
      this.toggle = this.querySelector('.merchandise-type__toggle');
      this.panel = this.querySelector('.merchandise-type__panel');
      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', () => {
        if (this.toggle.getAttribute('aria-expanded') === 'true') {
          this.close();
        } else {
          this.open();
        }
      });
    }

    open() {
      this.toggle.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      // Force a reflow so the transition runs from the collapsed state.
      this.panel.getBoundingClientRect();
      this.classList.add('is-open');
    }

    close() {
      this.toggle.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');

      const hidePanel = () => {
        if (!this.classList.contains('is-open')) this.panel.hidden = true;
      };

      if (window.getComputedStyle(this.panel).transitionDuration.split(',').every((d) => parseFloat(d) === 0)) {
        hidePanel();
      } else {
        this.panel.addEventListener('transitionend', hidePanel, { once: true });
      }
    }
  }

  customElements.define('merchandise-type-disclosure', MerchandiseTypeDisclosure);
}
